<template>
  <div class="caption-s">
    <span class="grade-part-1">{{ gradeParts[0] }}</span>
    <span v-if="gradeParts[1]" class="grade-part-2"> /{{ gradeParts[1] }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    gradeParts() {
      return this.item.grade ? this.item.grade.split("/") : [];
    },
  },
};
</script>

<style lang="scss" scoped>
.grade-part-2 {
  color: var(--color-text-neutral-secondary, #566370);
}
</style>
